/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import {
  EventAction,
  EventCategory,
  SearchItemTrigger,
} from "constants/tracking"
import { actionCreator } from "store/store"
import { actions } from "store/duck/menu"
import {
  PerformMenuItemSearchOptions,
  performMenuItemSearch,
} from "utils/rtk_migration_helper"
import { TroyWebTracker } from "utils/tracking"

interface PerformTrackedMenuItemSearchOptions {
  dispatch: PerformMenuItemSearchOptions["dispatch"]
  merchantID: string
  merchantGroupID: string
  isRtkFlagLoading: boolean
  isRtkSearchItemsEnabled: boolean
  searchItemsRtk: PerformMenuItemSearchOptions["searchItemsRtk"]
}

/**
 * Sends the searchItem event for a menu detail tab's search input and runs
 * the item search via RTK Query or legacy Redux. `value` must already be
 * trimmed, as the call sites debounce and trim before searching.
 */
export const performTrackedMenuItemSearch = async (
  value: string,
  category: EventCategory,
  options: PerformTrackedMenuItemSearchOptions,
) => {
  const {
    dispatch,
    merchantID,
    merchantGroupID,
    isRtkFlagLoading,
    isRtkSearchItemsEnabled,
    searchItemsRtk,
  } = options

  TroyWebTracker.sendEvent({
    category,
    action: EventAction.searchItem,
    labels: {
      ...(merchantID
        ? { STORE_ID: merchantID }
        : { MERCHANT_GROUP_ID: merchantGroupID }),
      SEARCH_TEXT: value,
      TRIGGER: SearchItemTrigger.searchInput,
    },
  })

  await performMenuItemSearch(value, {
    showLoading: true,
    searchItemsBaseAction: actions.SEARCH_ITEMS,
    dispatch,
    merchantID,
    merchantGroupID,
    isRtkFlagLoading,
    isRtkSearchItemsEnabled,
    searchItemsRtk,
    dispatchLegacySearch: () =>
      dispatch(
        actionCreator.menu.searchItems({
          merchantID,
          merchantGroupID,
          searchKey: value,
        }),
      ),
  })
}
